import { render, staticRenderFns } from "./Laureat.vue?vue&type=template&id=391ef4a6"
import script from "./Laureat.vue?vue&type=script&lang=js"
export * from "./Laureat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports